"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TotalLegend = void 0;
const react_1 = __importDefault(require("react"));
const components_1 = require("@veeam/components");
const core_1 = require("../../../core");
const helpers_1 = require("../../../helpers");
const Icons_1 = require("../../Icons");
require("./types");
exports.TotalLegend = react_1.default.memo(({ totalText, totalLabel, suffix, difference = core_1.COUNT_DIFFERENCE.notChanged, isTrendHidden }) => {
    const { t } = core_1.useFeatureContext();
    const total = totalLabel || t('legends|totalCircularLegend|total');
    const totalLabelStyle = !isTrendHidden ? { paddingLeft: 16 } : undefined;
    return (react_1.default.createElement(components_1.StackView, { direction: components_1.STACK_DIRECTION.column, align: components_1.STACK_ALIGN.center },
        react_1.default.createElement(components_1.StackView, { direction: components_1.STACK_DIRECTION.column, align: components_1.STACK_ALIGN.start },
            react_1.default.createElement(components_1.View, { indentLeft: components_1.VIEW_INDENT.xs },
                react_1.default.createElement(components_1.Text, { size: components_1.TEXT_SIZE.s, style: totalLabelStyle }, total)),
            react_1.default.createElement(components_1.StackView, { direction: components_1.STACK_DIRECTION.row, align: components_1.STACK_ALIGN.center },
                react_1.default.createElement(components_1.View, { indentRight: components_1.VIEW_INDENT.xs }, !isTrendHidden && react_1.default.createElement(Icons_1.ArrowIcon, { direction: helpers_1.getArrowDirection(difference) })),
                react_1.default.createElement(components_1.Text, { size: components_1.TEXT_SIZE.xl }, totalText),
                react_1.default.createElement(components_1.Text, { size: components_1.TEXT_SIZE.s, leader: components_1.INDENT.s, style: { paddingLeft: '4px' } }, suffix)))));
});
//# sourceMappingURL=TotalLegend.js.map